<template>
    <div class="rr-admin  dark:border-none">
        <Breadcrumb v-if="false" class="bg-transparent" :home="home" :model="$page.props.breadcrumb" >
            <template #item="{ item, props }">
                <Link v-if="item.route" :href="item.route">
                        <span :class="[item.icon, 'text-color']" />
                        <span class="text-sm">{{ item.label }}</span>
                </Link>
                <a v-else :href="item.url" :target="item.target" v-bind="props.action">
                    <span class="text-color">{{ item.label }}</span>
                </a>
            </template>
            <template #separator> / </template>
        </Breadcrumb>
        <transition name="page" mode="out-in">
            <div>
                <slot />
            </div>
        </transition>
    </div>
</template>
<script setup>
import Breadcrumb from 'primevue/breadcrumb';
import { ref, defineProps } from "vue";
import { Link } from '@inertiajs/vue3';
defineProps({
    title: String
})

const home = ref({
    icon: 'pi pi-home',
    route: '/app'
});

</script>
<style scoped lang="scss">
.p-breadcrumb {
    padding: 0;
    background-color: transparent;
    .p-menuitem-link, .pi {
        font-size: .875rem;
        color: var(--text-color) !important
    }
}

.page-enter-active,
.page-leave-active {
    transition: all 5s;
}

.page-enter-from,
.page-leave-to {
    opacity: 0;
}

</style>
